// extracted by css-extract-rspack-plugin
export default {"root":"root-GKuuPM","title":"title-VKShl2","content":"content-bvmMRG","label":"label-E41Sxz","value":"value-RchzoZ","actionConfirmAccess":"actionConfirmAccess-H6qYWk"};